/* global document */

import ReactDOM from 'react-dom';

// eslint-disable-next-line import/no-cycle
import LoginForm from 'profile/loginFormWidget/LoginForm';

const LoginFormWidget = (props) =>
  ReactDOM.createPortal(
    <>
      <LoginForm redirectTo={props.redirectTo} />
    </>,
    document.getElementById('c7-login-form')
  );

export default LoginFormWidget;
